export default __webpack_public_path__ + "static/avatar-penelope-6e5a2fd22dda922a1293f09caa58cb1f.png";